/**
 * ★ Fase 64 — Landing dedicata ALBANIA · NAREA.
 * URL: /f/it-al-na (IT-AL-NA) · ★ Fase 80: /f/es-al-na (ES-AL-NA, spagnolo) · ★ Fase 85: /f/en-al-na
 * (Three Garden ha ora la sua landing: ThreeGardenLanding.jsx → /f/it-al-tg)
 *
 * Costruite in HTML/React dai mockup cliente «HCF Estate» (stessa struttura
 * per i due asset, contenuti diversi). Flusso richiesto dal cliente:
 *   CTA → FORM DENTRO la landing (dialog) → lead salvato con il funnel code
 *   dedicato (IT-AL-NA → Telegram a Claudia, Calendly di Richard)
 *   → REDIRECT al funnel IT principale (/f/it?lead=ok) dove ogni link porta
 *   al Calendly di Richard.
 *
 * ★ Fase 95 (Doc 02) — senza cambiare URL/brand/palette/asset:
 *   • CTA primaria «Richiedi l’analisi preliminare di Narea» + microcopy «Nessun obbligo…»
 *   • dialog 3 step riusato (ZoomLeadDialog: contatti → qualifica → percorso HCF)
 *   • Scheda asset con disponibilità/prezzi LIVE dal CRM (mai hardcodati; «Verificata il»)
 *   • Dossier verificabile + confronto opportunità/rischi + percorso Form → Qualifica → Zoom → Pass
 *   • Verification Pass: cosa include / cosa NON include + date live + bridge verso l’hub
 *   • Prove specifiche Narea (ProofsSection) + FAQ extra · attribution + eventi `cta_click`
 *   Testi: nareaDoc02Content.js (IT/ES/EN).
 *
 * Palette (dal mockup, allineata ai token brand): crema/avorio, inchiostro,
 * bordeaux per le CTA, verde foresta per la sezione Verification Pass.
 * Logo: HCF Property attuale (variante scura su sfondo chiaro).
 */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import i18n from '../../../i18n';
import { api } from '../../../lib/api';
import { TestimonialsSection } from '../../../components/funnels/TestimonialsSection';
import { setPageMeta, ogImageFor } from '../../../lib/seo';
import { captureAttribution, trackFunnelEvent, withUtm } from '../../../lib/attribution';
import { ZoomLeadDialog } from '../../../components/funnels/ZoomLeadDialog';
import { ProofsSection, useVpDates } from '../../../components/funnels/Doc02Sections';
import { NoObligationNote } from '../../../components/funnels/NoObligationNote';
import { VpRecapVideo } from '../../../components/funnels/VpRecapVideo';
import { HCF_TESTIMONIALS } from '../../../lib/testimonials';
import { NAREA_DOC02 } from './nareaDoc02Content';
import {
  ArrowRight, PlayCircle, MapPin, Gem, Lock, FileBarChart2, UserRound,
  XCircle, CheckCircle2, Building2, ShieldCheck, Settings2, BarChart3,
  TrendingUp, Users, Plane, Hourglass, Menu, X, CalendarClock, HardHat,
  AlertTriangle,
} from 'lucide-react';
import {
  Accordion, AccordionItem, AccordionTrigger, AccordionContent,
} from '../../../components/ui/accordion';

/* ── Design tokens (mockup cliente) ── */
const CREAM = '#F6F1E8';
const CREAM_2 = '#EFE8DB';
const INK = '#17201C';
const INK_SOFT = '#4B5550';
const LINE = '#DED5C5';
const BURGUNDY = '#9B3B33';
const BURGUNDY_DEEP = '#7E2E28';
const FOREST = '#0F3B2E';
const FOREST_DEEP = '#0B2B22';
const GOLD = '#D6B25E';

/* Fallback: il valore live arriva da GET /public/funnel/it (booking_url). */

const LUX_CSS = `
  .aal-field { background: #FFFFFF; border: 1px solid ${LINE}; color: ${INK}; caret-color: ${BURGUNDY}; transition: border-color .2s, box-shadow .2s; }
  .aal-field::placeholder { color: #9AA39E; }
  .aal-field:hover:not(:focus) { border-color: #C9BDA6; }
  .aal-field:focus { border-color: ${BURGUNDY}; box-shadow: 0 0 0 3px rgba(155,59,51,0.16); outline: none; }
  .aal-btn-primary { background: ${BURGUNDY}; color: #FFF7EE; box-shadow: 0 10px 28px rgba(155,59,51,0.28); transition: transform .18s, background-color .18s, box-shadow .18s; }
  .aal-btn-primary:hover:not(:disabled) { background: ${BURGUNDY_DEEP}; transform: translateY(-1px); box-shadow: 0 14px 34px rgba(155,59,51,0.34); }
  .aal-btn-primary:active:not(:disabled) { transform: translateY(0); }
  .aal-btn-primary:disabled { opacity: .55; cursor: not-allowed; }
  .aal-btn-ghost { background: rgba(255,255,255,0.10); color: #FFF7EE; border: 1px solid rgba(255,255,255,0.45); backdrop-filter: blur(10px); transition: background-color .18s, transform .18s; }
  .aal-btn-ghost:hover { background: rgba(255,255,255,0.18); transform: translateY(-1px); }
  .aal-card { background: #FFFDF9; border: 1px solid ${LINE}; transition: transform .2s, box-shadow .2s; }
  .aal-card:hover { transform: translateY(-2px); box-shadow: 0 18px 40px rgba(23,32,28,0.08); }
  .aal-nav-link { color: ${INK_SOFT}; transition: color .15s; }
  .aal-nav-link:hover { color: ${INK}; }
  .aal-grain { position: absolute; inset: 0; pointer-events: none; opacity: .035; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='120' height='120' filter='url(%23n)'/%3E%3C/svg%3E"); }
  .aal-accordion-item { border: 1px solid ${LINE}; background: #FFFDF9; border-radius: 14px; padding: 0 1.1rem; }
  .aal-accordion-item [data-state] { border-bottom: 0; }
  .aal-link-ghost { color: #FFF7EE; border: 1px solid rgba(255,255,255,0.45); transition: background-color .18s, transform .18s; }
  .aal-link-ghost:hover { background: rgba(255,255,255,0.12); transform: translateY(-1px); }
  .aal-link-ghost:focus-visible { outline: 2px solid ${GOLD}; outline-offset: 3px; }
  @keyframes aal-pulse { 0%, 100% { opacity: .55; } 50% { opacity: 1; } }
  .aal-skeleton { display: inline-block; height: 1.1em; min-width: 7ch; border-radius: 6px; background: ${LINE}; animation: aal-pulse 1.4s ease-in-out infinite; vertical-align: middle; }
  @media (prefers-reduced-motion: reduce) { .aal-skeleton { animation: none; } }
`;

/* ★ Fase 95 — palette passata ai componenti Doc 02 riusabili (dialog 3 step, prove):
   la landing mantiene i propri colori (crema / bordeaux), nessun cambio brand. */
const TOKENS = {
  bg: CREAM, bg2: CREAM_2, paper: '#FFFDF9', ink: INK, inkSoft: INK_SOFT,
  accent: BURGUNDY, accentDeep: BURGUNDY_DEEP, line: LINE, soft: '#F3EAE2', onAccent: '#FFF7EE',
};

/* Badge di stato per il dossier (Subito · Analisi · Pass · In aggiornamento) */
const STATUS_STYLE = {
  now: { bg: '#E3EEE8', fg: FOREST },
  analysis: { bg: '#F3E3E0', fg: BURGUNDY_DEEP },
  pass: { bg: '#F6ECD2', fg: '#7A5A14' },
  todo: { bg: '#ECE7DD', fg: INK_SOFT },
};

const LOCALE = { it: 'it-IT', es: 'es-ES', en: 'en-GB' };
const fmtEur = (v, lang) => {
  try { return new Intl.NumberFormat(LOCALE[lang] || 'it-IT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(Number(v)); } catch { return `€${v}`; }
};
const fmtDate = (iso, lang) => {
  try { return new Date(iso).toLocaleDateString(LOCALE[lang] || 'it-IT', { day: '2-digit', month: 'long', year: 'numeric' }); } catch { return ''; }
};

/* ── Immagini NAREA (render ufficiali dal CRM) ── */
const NA_IMG = {
  heroWide: '/funnels/narea/narea-hero-wide.webp',
  sunset: '/funnels/narea/narea-sunset.webp',
  city: '/funnels/narea/narea-city.webp',
  pool: '/funnels/narea/narea-pool.webp',
  coast: '/funnels/narea/narea-coast.webp',
  street: '/funnels/narea/narea-street.webp',
  park: '/funnels/narea/narea-park.webp',
  coast2: '/funnels/narea/narea-coast-2.webp',
};

/* ── Testi UI per lingua (★ Fase 80 — IT + ES) ── */
const UI = {
  it: {
    headerCta: 'Richiedi accesso alla verifica', headerCtaShort: 'Richiedi accesso',
    nav: { asset: 'Asset', infra: 'Infrastruttura Patrimoniale', vp: 'Verification Pass', faq: 'FAQ' },
    menuOpen: 'Apri menu', menuClose: 'Chiudi menu', sections: 'Sezioni', logoAria: 'HCF Property — funnel principale',
    heroCta: 'Scopri il Verification Pass', heroSecondary: 'Guarda il progetto',
    trust: [
      { icon: Gem, t: 'Analisi guidata dell\u2019asset' },
      { icon: Lock, t: 'Accesso riservato e selettivo' },
      { icon: FileBarChart2, t: 'Valutazione dei punti chiave strategici' },
      { icon: UserRound, t: 'Form dedicato per il prossimo step' },
    ],
    vpTitle: ['Tutto parte', 'dalla verifica.'], vpLead: 'Il', vpName: 'Verification Pass',
    vpCta: 'Voglio iniziare dalla verifica', vpNote: 'Compili il form qui e prosegui nel percorso HCF completo.',
    vpIncludesTitle: ['Cosa include', 'il Verification Pass'],
    vpIncludes: [
      'Accesso alla verifica dell\u2019asset e dei suoi punti chiave',
      'Prima comprensione dell\u2019infrastruttura patrimoniale',
      'Analisi guidata con focus su opportunità e rischi',
      'Passaggio finale al confronto diretto con il nostro team',
    ],
    faqKicker: 'Risposte alle tue domande', faqTitle: 'FAQ',
    finalCta: 'Richiedi ora il tuo accesso alla verifica', finalNote: 'Form in pagina · poi il percorso HCF completo',
    footerFunnel: 'Percorso HCF', footerPrivacy: 'Privacy', footerCookies: 'Cookie', footerSections: 'Sezioni (footer)',
    stickyCta: 'Richiedi accesso alla verifica',
    dlg: {
      title: 'Inizia dalla verifica.',
      descBrochure: (asset) => <>Lascia i tuoi contatti: ricevi <b>subito via email la brochure {asset}</b> e ti portiamo al percorso HCF completo, dove potrai prenotare una consulenza strategica col CEO.</>,
      desc: <>Lascia i tuoi contatti: subito dopo ti portiamo al percorso HCF completo, dove potrai prenotare una consulenza strategica col CEO.</>,
      phName: 'Nome e cognome *', phEmail: 'Email *', phPhone: 'Telefono (consigliato)',
      submit: 'Richiedi accesso alla verifica',
      legal: 'Nessun obbligo di acquisto. Inviando accetti la nostra', privacy: 'Privacy Policy',
      okTitle: 'Richiesta ricevuta',
      okBrochure: (asset) => <>La <b>brochure {asset}</b> è in arrivo nella tua casella email. Ora ti portiamo al percorso HCF completo (video + Verification Pass): lì potrai prenotare una <b>consulenza strategica col CEO</b>.</>,
      ok: <>Ti stiamo portando al percorso HCF completo. Lì potrai prenotare una <b>consulenza strategica col CEO</b> di HCF Group.</>,
      okCta: 'Continua nel percorso HCF', okNote: 'La consulenza strategica col CEO si prenota dal percorso HCF.',
      toastTitle: 'Richiesta ricevuta!',
      toastBrochure: 'Ti abbiamo inviato la brochure via email. Ora ti portiamo al percorso completo HCF.',
      toast: 'Ti portiamo al percorso completo HCF: potrai prenotare una consulenza strategica col CEO.',
      toastErr: 'Invio non riuscito, riprova.',
    },
  },
  es: {
    headerCta: 'Solicita acceso a la verificación', headerCtaShort: 'Solicita acceso',
    nav: { asset: 'Activo', infra: 'Infraestructura Patrimonial', vp: 'Verification Pass', faq: 'FAQ' },
    menuOpen: 'Abrir menú', menuClose: 'Cerrar menú', sections: 'Secciones', logoAria: 'HCF Property — funnel principal',
    heroCta: 'Descubre el Verification Pass', heroSecondary: 'Mira el proyecto',
    trust: [
      { icon: Gem, t: 'Análisis guiado del activo' },
      { icon: Lock, t: 'Acceso reservado y selectivo' },
      { icon: FileBarChart2, t: 'Evaluación de los puntos clave estratégicos' },
      { icon: UserRound, t: 'Formulario dedicado para el siguiente paso' },
    ],
    vpTitle: ['Todo empieza', 'por la verificación.'], vpLead: 'El', vpName: 'Verification Pass',
    vpCta: 'Quiero empezar por la verificación', vpNote: 'Rellena el formulario aquí y continúa en el recorrido HCF completo.',
    vpIncludesTitle: ['Qué incluye', 'el Verification Pass'],
    vpIncludes: [
      'Acceso a la verificación del activo y de sus puntos clave',
      'Primera comprensión de la infraestructura patrimonial',
      'Análisis guiado con foco en oportunidades y riesgos',
      'Paso final al contacto directo con nuestro equipo',
    ],
    faqKicker: 'Respuestas a tus preguntas', faqTitle: 'Preguntas frecuentes',
    finalCta: 'Solicita ahora tu acceso a la verificación', finalNote: 'Formulario en la página · luego el recorrido HCF completo',
    footerFunnel: 'Recorrido HCF', footerPrivacy: 'Privacidad', footerCookies: 'Cookies', footerSections: 'Secciones (pie)',
    stickyCta: 'Solicita acceso a la verificación',
    dlg: {
      title: 'Empieza por la verificación.',
      descBrochure: (asset) => <>Déjanos tus datos: recibes <b>ahora mismo por email el brochure {asset}</b> y te llevamos al recorrido HCF completo, donde podrás reservar una consultoría estratégica.</>,
      desc: <>Déjanos tus datos: justo después te llevamos al recorrido HCF completo, donde podrás reservar una consultoría estratégica con nuestro equipo.</>,
      phName: 'Nombre y apellidos *', phEmail: 'Email *', phPhone: 'Teléfono (recomendado)',
      submit: 'Solicita acceso a la verificación',
      legal: 'Sin obligación de compra. Al enviar aceptas nuestra', privacy: 'Política de Privacidad',
      okTitle: 'Solicitud recibida',
      okBrochure: (asset) => <>El <b>brochure {asset}</b> está llegando a tu correo. Ahora te llevamos al recorrido HCF completo (vídeo + Verification Pass): allí podrás reservar una <b>consultoría estratégica</b>.</>,
      ok: <>Te estamos llevando al recorrido HCF completo. Allí podrás reservar una <b>consultoría estratégica</b> con el equipo de HCF Group.</>,
      okCta: 'Continúa en el recorrido HCF', okNote: 'La consultoría estratégica se reserva desde el recorrido HCF.',
      toastTitle: '¡Solicitud recibida!',
      toastBrochure: 'Te hemos enviado el brochure por email. Ahora te llevamos al recorrido HCF completo.',
      toast: 'Te llevamos al recorrido HCF completo: podrás reservar una consultoría estratégica.',
      toastErr: 'No se pudo enviar, inténtalo de nuevo.',
    },
  },
  // ★ Fase 85 — English UI (EN-AL-NA)
  en: {
    headerCta: 'Request verification access', headerCtaShort: 'Request access',
    nav: { asset: 'Asset', infra: 'Wealth Infrastructure', vp: 'Verification Pass', faq: 'FAQ' },
    menuOpen: 'Open menu', menuClose: 'Close menu', sections: 'Sections', logoAria: 'HCF Property — main funnel',
    heroCta: 'Discover the Verification Pass', heroSecondary: 'See the project',
    trust: [
      { icon: Gem, t: 'Guided analysis of the asset' },
      { icon: Lock, t: 'Reserved and selective access' },
      { icon: FileBarChart2, t: 'Assessment of the key strategic points' },
      { icon: UserRound, t: 'Dedicated form for the next step' },
    ],
    vpTitle: ['It all starts', 'with verification.'], vpLead: 'The', vpName: 'Verification Pass',
    vpCta: 'I want to start with verification', vpNote: 'Fill in the form here and continue in the full HCF journey.',
    vpIncludesTitle: ['What the Verification Pass', 'includes'],
    vpIncludes: [
      'Access to the verification of the asset and its key points',
      'First understanding of the wealth infrastructure',
      'Guided analysis focused on opportunities and risks',
      'Final step to direct contact with our team',
    ],
    faqKicker: 'Answers to your questions', faqTitle: 'Frequently asked questions',
    finalCta: 'Request your verification access now', finalNote: 'Form on the page · then the full HCF journey',
    footerFunnel: 'HCF journey', footerPrivacy: 'Privacy', footerCookies: 'Cookies', footerSections: 'Sections (footer)',
    stickyCta: 'Request verification access',
    dlg: {
      title: 'Start with verification.',
      descBrochure: (asset) => <>Leave us your details: you receive <b>the {asset} brochure by email right away</b> and we take you to the full HCF journey, where you can book a strategic consultation.</>,
      desc: <>Leave us your details: right after, we take you to the full HCF journey, where you can book a strategic consultation with our team.</>,
      phName: 'Full name *', phEmail: 'Email *', phPhone: 'Phone (recommended)',
      submit: 'Request verification access',
      legal: 'No obligation to buy. By submitting you accept our', privacy: 'Privacy Policy',
      okTitle: 'Request received',
      okBrochure: (asset) => <>The <b>{asset} brochure</b> is on its way to your inbox. Now we take you to the full HCF journey (video + Verification Pass): there you can book a <b>strategic consultation</b>.</>,
      ok: <>We are taking you to the full HCF journey. There you can book a <b>strategic consultation</b> with the HCF Group team.</>,
      okCta: 'Continue in the HCF journey', okNote: 'The strategic consultation is booked from the HCF journey.',
      toastTitle: 'Request received!',
      toastBrochure: 'We have sent you the brochure by email. Now we take you to the full HCF journey.',
      toast: 'We take you to the full HCF journey: you will be able to book a strategic consultation.',
      toastErr: 'Could not send, please try again.',
    },
  },
};

const LANDINGS = {
  'it-al-na': {
    code: 'IT-AL-NA',
    lang: 'it',
    homeHref: '/f/it',
    propertySlug: 'narea',
    name: 'Narea',
    assetName: 'Narea',
    // ★ Fase 68 — al submit del form il lead riceve SUBITO la brochure via email
    brochureEmail: true,
    brochureUrl: '/funnels/narea-brochure.pdf',
    place: 'Albania',
    docTitle: 'Narea · Albania — HCF Property',
    docDescription: 'Narea, nuova visione sulla costa albanese: 14 piani, 161 appartamenti, consegna 2029. Richiedi accesso alla verifica sul campo con HCF Property.',
    navWhy: 'Perché Albania',
    hero: {
      kicker: ['Albania', 'Asset esclusivo', 'Visione patrimoniale'],
      title1: 'Non stai comprando solo un immobile.',
      title2: 'Stai entrando in un\u2019infrastruttura patrimoniale.',
      text: 'Un asset iconico in una destinazione strategica. Bellezza, crescita, accesso. Ma il vero valore sta nel capire come si integra in una visione patrimoniale strutturata.',
      image: NA_IMG.heroWide,
      badgeTitle: 'Albania',
      badgeText: 'Una nuova prospettiva per il tuo patrimonio.',
    },
    myths: {
      kicker: 'Nuovi mercati, nuove opportunità',
      title: 'Le credenze che ti fanno perdere opportunità.',
      intro: 'L\u2019Albania è spesso vittima di falsi miti. È il momento di guardare oltre, con dati, visione e un approccio strutturato.',
      items: [
        { img: NA_IMG.coast2, myth: 'L\u2019Albania è ancora un mercato secondario.', truth: 'Oggi è una destinazione in forte evoluzione, con crescente interesse internazionale e investimenti infrastrutturali.' },
        { img: NA_IMG.city, myth: 'Basta comprare un immobile per aver fatto un investimento.', truth: 'Un vero investimento richiede analisi, governance e una visione patrimoniale di lungo periodo.' },
        { img: NA_IMG.street, myth: 'Conta solo il prezzo d\u2019ingresso.', truth: 'Il prezzo è solo una variabile. Contano posizionamento, qualità dell\u2019asset e potenziale di valorizzazione.' },
        { img: NA_IMG.pool, myth: 'L\u2019estetica non conta nella valorizzazione.', truth: 'Un\u2019architettura iconica e riconoscibile aumenta l\u2019attrattività, la percezione del valore e la domanda nel tempo.' },
      ],
    },
    infra: {
      kicker: 'Più di un immobile',
      title: 'Cos\u2019è un\u2019infrastruttura patrimoniale?',
      text: 'Non è solo un immobile. È un sistema integrato di asset, governance, gestione e visione che lavora nel tempo per il tuo patrimonio.',
      image: NA_IMG.sunset,
      pillars: [
        { icon: Building2, t: 'Asset', d: 'Un immobile strategico in una location ad alto potenziale.' },
        { icon: ShieldCheck, t: 'Governance', d: 'Struttura, regole e protezione per il tuo investimento.' },
        { icon: Settings2, t: 'Gestione', d: 'Approccio professionale alla gestione e valorizzazione.' },
        { icon: BarChart3, t: 'Flussi e visione patrimoniale', d: 'Un orizzonte di lungo periodo, con potenziale di reddito e crescita.' },
      ],
      quote: 'Un\u2019infrastruttura patrimoniale trasforma un\u2019opportunità in un vantaggio duraturo.',
    },
    arch: {
      kicker: 'Design iconico nel cuore del Mediterraneo',
      title: 'Un\u2019architettura che non passa inosservata.',
      intro: 'Linee scultoree, vegetazione integrata e spazi pensati per un\u2019esperienza esclusiva. Un progetto iconico, capace di unire estetica, funzionalità e valore.',
      items: [
        { img: NA_IMG.coast, cap: 'Design iconico e contemporaneo' },
        { img: NA_IMG.pool, cap: 'Vegetazione integrata e architettura sostenibile' },
        { img: NA_IMG.street, cap: 'Piscina centrale e spazi comuni di alto livello' },
        { img: NA_IMG.park, cap: 'Forte impatto visivo e percezione premium' },
      ],
    },
    why: {
      kicker: 'Una destinazione strategica',
      title: 'Perché Albania, perché ora.',
      intro: 'Una posizione unica, un Paese in trasformazione e un interesse internazionale in crescita. L\u2019Albania offre oggi una combinazione rara di opportunità, accessibilità e prospettive di sviluppo.',
      items: [
        { icon: TrendingUp, t: 'Crescita percepibile', d: 'Un Paese in evoluzione con investimenti sempre più rilevanti.' },
        { icon: MapPin, t: 'Posizione strategica sul Mediterraneo', d: 'Un ponte naturale tra Europa e mercati internazionali.' },
        { icon: BarChart3, t: 'Mercato in evoluzione', d: 'Nuove opportunità in un contesto in rapida trasformazione.' },
        { icon: Plane, t: 'Accessibilità europea', d: 'Facilmente raggiungibile, con una connessione sempre più forte con l\u2019UE.' },
        { icon: Hourglass, t: 'Finestra di posizionamento', d: 'Un momento favorevole per muoversi con visione e anticipo.' },
        { icon: Users, t: 'Interesse crescente', d: 'Una destinazione sempre più presente nel radar di investitori internazionali.' },
      ],
    },
    vp: {
      kicker: 'Il primo passo, il più importante',
      textAfter: 'è il tuo accesso alla valutazione iniziale dell\u2019asset e alla comprensione della sua infrastruttura patrimoniale. Un passo essenziale prima di ogni decisione.',
      image: NA_IMG.pool,
    },
    faq: {
      intro: 'Le informazioni essenziali per iniziare con chiarezza e consapevolezza.',
      image: NA_IMG.coast,
      items: [
        { q: 'Cos\u2019è esattamente il Verification Pass?', a: 'È un percorso di verifica guidata: accesso alla documentazione dell\u2019asset, lettura del territorio e visita on-site con il team HCF. Non è una vendita: è il primo passo per capire se Narea ha senso nella tua strategia patrimoniale.' },
        { q: 'Il pass mi obbliga all\u2019acquisto?', a: 'No. Nessun obbligo di acquisto. Il Verification Pass serve a decidere con dati verificati di persona, non con rendering o promesse.' },
        { q: 'Perché iniziare dalla verifica?', a: 'Perché il valore reale nasce da posizione, domanda, qualità dell\u2019asset e governance: elementi che si controllano sul campo prima di qualsiasi decisione.' },
        { q: 'Cosa significa infrastruttura patrimoniale?', a: 'Un sistema integrato di asset, governance, gestione e visione di lungo periodo che lavora nel tempo per il tuo patrimonio. Non la singola unità, ma il modo in cui si inserisce in una strategia.' },
        { q: 'Perché Albania oggi?', a: 'Crescita percepibile, posizione strategica sul Mediterraneo, accessibilità europea e un interesse internazionale in aumento: una finestra di posizionamento da valutare con anticipo e metodo.' },
      ],
    },
    final: {
      kicker: 'Il tuo prossimo passo',
      title1: 'Le migliori opportunità non iniziano dall\u2019acquisto.',
      title2: 'Iniziano dalla comprensione.',
      text: 'Richiedi ora il tuo accesso alla verifica e scopri se questo asset è adatto alla tua strategia patrimoniale.',
      image: NA_IMG.sunset,
    },
    formKicker: 'Richiedi accesso alla verifica · Narea',
    leadMessage: 'Richiesta accesso Verification Pass — Narea (Albania) · landing IT-AL-NA',
  },

  // ★ Fase 80 — NAREA en ESPAÑOL (ES-AL-NA): mismo layout, copy traducido.
  //   Brochure ES: NO disponible todavía (el cliente la enviará) → sin email.
  'es-al-na': {
    code: 'ES-AL-NA',
    lang: 'es',
    homeHref: '/f/es',
    propertySlug: 'es-narea',
    name: 'Narea',
    assetName: 'Narea',
    brochureEmail: false,
    place: 'Albania',
    docTitle: 'Narea · Albania — HCF Property',
    docDescription: 'Narea, nueva visión en la costa albanesa: 14 plantas, 161 apartamentos, entrega 2029. Solicita acceso a la verificación in situ con HCF Property.',
    navWhy: 'Por qué Albania',
    hero: {
      kicker: ['Albania', 'Activo exclusivo', 'Visión patrimonial'],
      title1: 'No estás comprando solo un inmueble.',
      title2: 'Estás entrando en una infraestructura patrimonial.',
      text: 'Un activo icónico en un destino estratégico. Belleza, crecimiento, acceso. Pero el verdadero valor está en entender cómo se integra en una visión patrimonial estructurada.',
      image: NA_IMG.heroWide,
      badgeTitle: 'Albania',
      badgeText: 'Una nueva perspectiva para tu patrimonio.',
    },
    myths: {
      kicker: 'Nuevos mercados, nuevas oportunidades',
      title: 'Las creencias que te hacen perder oportunidades.',
      intro: 'Albania es a menudo víctima de falsos mitos. Es el momento de mirar más allá, con datos, visión y un enfoque estructurado.',
      items: [
        { img: NA_IMG.coast2, myth: 'Albania sigue siendo un mercado secundario.', truth: 'Hoy es un destino en plena evolución, con creciente interés internacional e inversiones en infraestructuras.' },
        { img: NA_IMG.city, myth: 'Basta con comprar un inmueble para haber hecho una inversión.', truth: 'Una verdadera inversión requiere análisis, governance y una visión patrimonial a largo plazo.' },
        { img: NA_IMG.street, myth: 'Solo cuenta el precio de entrada.', truth: 'El precio es solo una variable. Cuentan el posicionamiento, la calidad del activo y el potencial de revalorización.' },
        { img: NA_IMG.pool, myth: 'La estética no cuenta en la revalorización.', truth: 'Una arquitectura icónica y reconocible aumenta el atractivo, la percepción de valor y la demanda en el tiempo.' },
      ],
    },
    infra: {
      kicker: 'Más que un inmueble',
      title: '¿Qué es una infraestructura patrimonial?',
      text: 'No es solo un inmueble. Es un sistema integrado de activos, governance, gestión y visión que trabaja en el tiempo para tu patrimonio.',
      image: NA_IMG.sunset,
      pillars: [
        { icon: Building2, t: 'Activo', d: 'Un inmueble estratégico en una ubicación de alto potencial.' },
        { icon: ShieldCheck, t: 'Governance', d: 'Estructura, reglas y protección para tu inversión.' },
        { icon: Settings2, t: 'Gestión', d: 'Enfoque profesional de la gestión y la revalorización.' },
        { icon: BarChart3, t: 'Flujos y visión patrimonial', d: 'Un horizonte a largo plazo, con potencial de renta y crecimiento.' },
      ],
      quote: 'Una infraestructura patrimonial transforma una oportunidad en una ventaja duradera.',
    },
    arch: {
      kicker: 'Diseño icónico en el corazón del Mediterráneo',
      title: 'Una arquitectura que no pasa desapercibida.',
      intro: 'Líneas escultóricas, vegetación integrada y espacios pensados para una experiencia exclusiva. Un proyecto icónico, capaz de unir estética, funcionalidad y valor.',
      items: [
        { img: NA_IMG.coast, cap: 'Diseño icónico y contemporáneo' },
        { img: NA_IMG.pool, cap: 'Vegetación integrada y arquitectura sostenible' },
        { img: NA_IMG.street, cap: 'Piscina central y zonas comunes de alto nivel' },
        { img: NA_IMG.park, cap: 'Fuerte impacto visual y percepción premium' },
      ],
    },
    why: {
      kicker: 'Un destino estratégico',
      title: 'Por qué Albania, por qué ahora.',
      intro: 'Una posición única, un país en transformación y un interés internacional en crecimiento. Albania ofrece hoy una combinación poco común de oportunidad, accesibilidad y perspectivas de desarrollo.',
      items: [
        { icon: TrendingUp, t: 'Crecimiento perceptible', d: 'Un país en evolución con inversiones cada vez más relevantes.' },
        { icon: MapPin, t: 'Posición estratégica en el Mediterráneo', d: 'Un puente natural entre Europa y los mercados internacionales.' },
        { icon: BarChart3, t: 'Mercado en evolución', d: 'Nuevas oportunidades en un contexto en rápida transformación.' },
        { icon: Plane, t: 'Accesibilidad europea', d: 'Fácil de alcanzar, con una conexión cada vez más fuerte con la UE.' },
        { icon: Hourglass, t: 'Ventana de posicionamiento', d: 'Un momento favorable para moverse con visión y anticipación.' },
        { icon: Users, t: 'Interés creciente', d: 'Un destino cada vez más presente en el radar de los inversores internacionales.' },
      ],
    },
    vp: {
      kicker: 'El primer paso, el más importante',
      textAfter: 'es tu acceso a la evaluación inicial del activo y a la comprensión de su infraestructura patrimonial. Un paso esencial antes de cualquier decisión.',
      image: NA_IMG.pool,
    },
    faq: {
      intro: 'La información esencial para empezar con claridad y conciencia.',
      image: NA_IMG.coast,
      items: [
        { q: '¿Qué es exactamente el Verification Pass?', a: 'Es un recorrido de verificación guiada: acceso a la documentación del activo, lectura del territorio y visita on-site con el equipo HCF. No es una venta: es el primer paso para entender si Narea tiene sentido en tu estrategia patrimonial.' },
        { q: '¿El pass me obliga a comprar?', a: 'No. Sin obligación de compra. El Verification Pass sirve para decidir con datos verificados en persona, no con renders ni promesas.' },
        { q: '¿Por qué empezar por la verificación?', a: 'Porque el valor real nace de la ubicación, la demanda, la calidad del activo y la governance: elementos que se comprueban sobre el terreno antes de cualquier decisión.' },
        { q: '¿Qué significa infraestructura patrimonial?', a: 'Un sistema integrado de activos, governance, gestión y visión a largo plazo que trabaja en el tiempo para tu patrimonio. No la unidad aislada, sino la forma en que se inserta en una estrategia.' },
        { q: '¿Por qué Albania hoy?', a: 'Crecimiento perceptible, posición estratégica en el Mediterráneo, accesibilidad europea y un interés internacional en aumento: una ventana de posicionamiento que conviene evaluar con anticipación y método.' },
      ],
    },
    final: {
      kicker: 'Tu próximo paso',
      title1: 'Las mejores oportunidades no empiezan por la compra.',
      title2: 'Empiezan por la comprensión.',
      text: 'Solicita ahora tu acceso a la verificación y descubre si este activo encaja en tu estrategia patrimonial.',
      image: NA_IMG.sunset,
    },
    formKicker: 'Solicita acceso a la verificación · Narea',
    leadMessage: 'Solicitud acceso Verification Pass — Narea (Albania) · landing ES-AL-NA',
  },
  // ★ Fase 85 — Narea · ENGLISH landing (EN-AL-NA), twin of ES-AL-NA
  'en-al-na': {
    code: 'EN-AL-NA',
    lang: 'en',
    homeHref: '/f/en',
    propertySlug: 'en-narea',
    name: 'Narea',
    assetName: 'Narea',
    brochureEmail: false,
    place: 'Albania',
    docTitle: 'Narea · Albania — HCF Property',
    docDescription: 'Narea, a new vision on the Albanian coast: 14 floors, 161 apartments, delivery 2029. Request on-site verification access with HCF Property.',
    navWhy: 'Why Albania',
    hero: {
      kicker: ['Albania', 'Exclusive asset', 'Wealth vision'],
      title1: 'You are not just buying a property.',
      title2: 'You are entering a wealth infrastructure.',
      text: 'An iconic asset in a strategic destination. Beauty, growth, access. But the real value lies in understanding how it fits into a structured wealth vision.',
      image: NA_IMG.heroWide,
      badgeTitle: 'Albania',
      badgeText: 'A new perspective for your wealth.',
    },
    myths: {
      kicker: 'New markets, new opportunities',
      title: 'The beliefs that make you miss opportunities.',
      intro: 'Albania is often the victim of false myths. It is time to look further, with data, vision and a structured approach.',
      items: [
        { img: NA_IMG.coast2, myth: 'Albania is still a secondary market.', truth: 'Today it is a destination in full evolution, with growing international interest and infrastructure investment.' },
        { img: NA_IMG.city, myth: 'Buying a property is enough to have made an investment.', truth: 'A real investment requires analysis, governance and a long-term wealth vision.' },
        { img: NA_IMG.street, myth: 'Only the entry price matters.', truth: 'Price is just one variable. Positioning, asset quality and appreciation potential matter.' },
        { img: NA_IMG.pool, myth: 'Aesthetics do not count for appreciation.', truth: 'Iconic, recognisable architecture increases appeal, perceived value and demand over time.' },
      ],
    },
    infra: {
      kicker: 'More than a property',
      title: 'What is a wealth infrastructure?',
      text: 'It is not just a property. It is an integrated system of assets, governance, management and vision that works over time for your wealth.',
      image: NA_IMG.sunset,
      pillars: [
        { icon: Building2, t: 'Asset', d: 'A strategic property in a high-potential location.' },
        { icon: ShieldCheck, t: 'Governance', d: 'Structure, rules and protection for your investment.' },
        { icon: Settings2, t: 'Management', d: 'A professional approach to management and appreciation.' },
        { icon: BarChart3, t: 'Cash flows and wealth vision', d: 'A long-term horizon, with income and growth potential.' },
      ],
      quote: 'A wealth infrastructure turns an opportunity into a lasting advantage.',
    },
    arch: {
      kicker: 'Iconic design in the heart of the Mediterranean',
      title: 'Architecture that does not go unnoticed.',
      intro: 'Sculptural lines, integrated greenery and spaces designed for an exclusive experience. An iconic project, able to combine aesthetics, functionality and value.',
      items: [
        { img: NA_IMG.coast, cap: 'Iconic, contemporary design' },
        { img: NA_IMG.pool, cap: 'Integrated greenery and sustainable architecture' },
        { img: NA_IMG.street, cap: 'Central pool and high-end common areas' },
        { img: NA_IMG.park, cap: 'Strong visual impact and premium perception' },
      ],
    },
    why: {
      kicker: 'A strategic destination',
      title: 'Why Albania, why now.',
      intro: 'A unique position, a country in transformation and growing international interest. Albania today offers a rare combination of opportunity, accessibility and development prospects.',
      items: [
        { icon: TrendingUp, t: 'Perceptible growth', d: 'An evolving country with increasingly relevant investments.' },
        { icon: MapPin, t: 'Strategic position in the Mediterranean', d: 'A natural bridge between Europe and international markets.' },
        { icon: BarChart3, t: 'Evolving market', d: 'New opportunities in a rapidly transforming context.' },
        { icon: Plane, t: 'European accessibility', d: 'Easy to reach, with an ever stronger connection to the EU.' },
        { icon: Hourglass, t: 'Positioning window', d: 'A favourable moment to move with vision and anticipation.' },
        { icon: Users, t: 'Growing interest', d: 'A destination increasingly on the radar of international investors.' },
      ],
    },
    vp: {
      kicker: 'The first step, the most important',
      textAfter: 'is your access to the initial assessment of the asset and to the understanding of its wealth infrastructure. An essential step before any decision.',
      image: NA_IMG.pool,
    },
    faq: {
      intro: 'The essential information to start with clarity and awareness.',
      image: NA_IMG.coast,
      items: [
        { q: 'What exactly is the Verification Pass?', a: 'It is a guided verification journey: access to the asset documentation, territory reading and on-site visit with the HCF team. It is not a sale: it is the first step to understand whether Narea makes sense in your wealth strategy.' },
        { q: 'Does the pass oblige me to buy?', a: 'No. No obligation to buy. The Verification Pass is there to decide with data verified in person, not with renders or promises.' },
        { q: 'Why start with verification?', a: 'Because real value is born from location, demand, asset quality and governance: elements that are checked on the ground before any decision.' },
        { q: 'What does wealth infrastructure mean?', a: 'An integrated system of assets, governance, management and long-term vision that works over time for your wealth. Not the isolated unit, but the way it fits into a strategy.' },
        { q: 'Why Albania today?', a: 'Perceptible growth, strategic position in the Mediterranean, European accessibility and rising international interest: a positioning window worth assessing with anticipation and method.' },
      ],
    },
    final: {
      kicker: 'Your next step',
      title1: 'The best opportunities do not start with the purchase.',
      title2: 'They start with understanding.',
      text: 'Request your verification access now and find out whether this asset fits your wealth strategy.',
      image: NA_IMG.sunset,
    },
    formKicker: 'Request verification access · Narea',
    leadMessage: 'Verification Pass access request — Narea (Albania) · landing EN-AL-NA',
  },
};

/* ── UI atoms ── */
const Kicker = ({ children, light = false }) => (
  <div className="text-[11px] md:text-xs font-sans font-semibold tracking-[0.28em] uppercase" style={{ color: light ? GOLD : BURGUNDY }}>
    {children}
  </div>
);

const SectionTitle = ({ children, light = false, className = '', testId }) => (
  <h2
    className={`font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight ${className}`}
    style={{ color: light ? '#FFF7EE' : INK }}
    data-testid={testId}
  >
    {children}
  </h2>
);

function PrimaryBtn({ children, onClick, testId, className = '', type = 'button', disabled = false }) {
  return (
    <button
      type={type} onClick={onClick} disabled={disabled}
      className={`aal-btn-primary inline-flex items-center justify-center gap-2 rounded-xl px-6 h-12 text-[13px] sm:text-sm font-sans font-semibold ${className}`}
      data-testid={testId}
    >
      {children}
    </button>
  );
}


/* ── Form lead: ★ Fase 95 → ZoomLeadDialog (3 step) in components/funnels/ZoomLeadDialog.jsx ── */

/* ── ★ Fase 95 — atoms per la scheda asset / dossier ── */
function Fact({ label, value, testId, loading = false }) {
  return (
    <div className="min-w-0" data-testid={testId}>
      <dt className="text-[10.5px] font-sans font-semibold tracking-[0.18em] uppercase" style={{ color: INK_SOFT }}>{label}</dt>
      <dd className="mt-1 font-serif text-[17px] leading-snug" style={{ color: INK }}>
        {loading ? <span className="aal-skeleton" aria-hidden="true" /> : value}
      </dd>
    </div>
  );
}

function StatusBadge({ status, label, testId }) {
  const s = STATUS_STYLE[status] || STATUS_STYLE.todo;
  return (
    <span className="inline-flex items-center rounded-full px-2.5 py-1 text-[10.5px] font-sans font-bold tracking-[0.08em] uppercase whitespace-nowrap" style={{ background: s.bg, color: s.fg }} data-testid={testId} data-status={status}>
      {label}
    </span>
  );
}

/* ── Pagina ── */
export default function AlbaniaAssetLanding({ slug }) {
  const cfg = LANDINGS[slug];
  const lang = cfg?.lang || 'it';
  const t = UI[lang];
  const d = NAREA_DOC02[lang] || NAREA_DOC02.it; // ★ Fase 95 — testi Doc 02
  const [formOpen, setFormOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  // ★ Fase 95 — scheda asset LIVE (disponibilità/prezzo/verifica) dal CRM: nessun numero hardcodato
  const [asset, setAsset] = useState({ loaded: false, live: false, available: null, total: null, startingFrom: null, verifiedAt: null });
  // ★ Fase 95 — date Verification Pass live (IT-AL / ES-AL / EN-AL)
  const { dates: vpDates } = useVpDates(d.vpExtra?.vpSource);

  useEffect(() => {
    if (!cfg) return;
    if (i18n.language !== lang) i18n.changeLanguage(lang);
    // ★ Fase 89 — meta social: thumbnail = card Narea, og:url = link specifico
    setPageMeta({
      title: cfg.docTitle,
      description: cfg.docDescription,
      image: ogImageFor(slug),
      imageAlt: `Narea · Albania — HCF Property`,
      path: `/f/${slug}`,
      locale: lang,
    });
    captureAttribution(); // ★ Fase 91/95 — utm_*, click_id, first_touch, landing_path preservati
    window.scrollTo(0, 0);
  }, [cfg, lang, slug]);

  useEffect(() => {
    if (!cfg) return undefined;
    let alive = true;
    // L'asset fisico è unico: le unità vivono sul progetto canonico `narea` (IT). Fallback: slug della lingua.
    api.get('/public/properties')
      .then((r) => {
        if (!alive) return;
        const list = Array.isArray(r.data) ? r.data : [];
        const live = list.find((p) => p.slug === 'narea' && p.last_units_sync) || list.find((p) => p.slug === cfg.propertySlug);
        const apts = live?.apartments || {};
        setAsset({
          loaded: true,
          live: !!live?.last_units_sync,
          available: typeof apts.available === 'number' ? apts.available : null,
          total: typeof apts.total === 'number' ? apts.total : null,
          startingFrom: typeof apts.starting_from === 'number' ? apts.starting_from : null,
          verifiedAt: live?.units_verified_at || null,
        });
      })
      .catch(() => { if (alive) setAsset((a) => ({ ...a, loaded: true })); });
    return () => { alive = false; };
  }, [cfg]);

  if (!cfg) return null;

  const scrollTo = (id) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  // ★ Fase 95 — ogni CTA verso il form traccia `cta_click` (solo con consenso analytics)
  const openForm = (label) => {
    setMenuOpen(false);
    trackFunnelEvent('cta_click', { funnel: slug, label: typeof label === 'string' ? label : d.ctaPrimary, target: 'form' });
    setFormOpen(true);
  };
  const hubHref = withUtm(d.vpExtra.hubHref);
  const onHubClick = () => trackFunnelEvent('cta_click', { funnel: slug, label: 'verification_pass_bridge', target: d.vpExtra.hubHref });

  const availabilityVerified = asset.loaded && asset.live && asset.available !== null && asset.total !== null;
  const L = d.sheet.labels;

  // ★ Fase 95 — prove: titoli dinamici (conteggio testimonianze), disponibilità live, azioni (scroll)
  const proofs = {
    ...d.proofs,
    items: d.proofs.items.map((p) => ({
      ...p,
      t: typeof p.t === 'function' ? p.t(HCF_TESTIMONIALS.length) : p.t,
      d: p.key === 'availability' ? (availabilityVerified ? d.proofs.availabilityText(asset.available, asset.total) : d.proofs.availabilityPending) : p.d,
      action: p.action ? { label: p.actionLabel, onClick: () => scrollTo(p.action) } : undefined,
    })),
  };

  const faqItems = [...cfg.faq.items, ...(d.faqExtra || [])];

  const NAV = [
    { id: 'scheda', label: d.navExtra[0].label },
    { id: 'perche', label: cfg.navWhy },
    { id: 'dossier', label: d.navExtra[1].label },
    { id: 'percorso', label: d.navExtra[2].label },
    { id: 'verification', label: t.nav.vp },
    { id: 'faq', label: t.nav.faq },
  ];

  return (
    <div className="relative min-h-screen font-sans" style={{ background: CREAM, color: INK }} data-testid={`albania-landing-${slug}`}>
      <style>{LUX_CSS}</style>

      {/* ── Header ── */}
      <header className="sticky top-0 z-40 border-b" style={{ background: 'rgba(246,241,232,0.92)', backdropFilter: 'blur(14px)', borderColor: LINE }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-3">
          <Link to={cfg.homeHref || '/f/it'} className="shrink-0" data-testid="aal-logo-home" aria-label={t.logoAria}>
            <img src="/funnels/hcf-logo-dark.png" alt="HCF Property" className="h-9 w-auto" />
          </Link>
          <nav className="hidden lg:flex items-center gap-5 xl:gap-7 text-[13px] font-medium" aria-label={t.sections}>
            {NAV.map((n) => (
              <button key={n.id} type="button" onClick={() => scrollTo(n.id)} className="aal-nav-link" data-testid={`aal-nav-${n.id}`}>{n.label}</button>
            ))}
          </nav>
          <div className="flex items-center gap-2">
            <PrimaryBtn onClick={() => openForm(d.ctaShort)} className="!h-10 !px-4 sm:!px-5 !text-[12px] sm:!text-[13px]" testId="aal-header-cta">
              <span className="hidden sm:inline">{d.ctaShort}</span>
              <span className="sm:hidden">{d.ctaShort}</span>
              <ArrowRight className="w-4 h-4" />
            </PrimaryBtn>
            <button
              type="button" onClick={() => setMenuOpen((v) => !v)}
              className="lg:hidden w-10 h-10 rounded-xl grid place-items-center border transition-colors hover:bg-black/5"
              style={{ borderColor: LINE, color: INK }}
              aria-label={menuOpen ? t.menuClose : t.menuOpen} aria-expanded={menuOpen}
              data-testid="aal-menu-toggle"
            >
              {menuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
        {menuOpen && (
          <nav className="lg:hidden border-t px-4 py-3 flex flex-col" style={{ borderColor: LINE, background: CREAM }} aria-label={`${t.sections} (mobile)`} data-testid="aal-mobile-menu">
            {NAV.map((n) => (
              <button key={n.id} type="button" onClick={() => scrollTo(n.id)} className="text-left py-3 text-[15px] font-medium border-b last:border-b-0" style={{ borderColor: LINE, color: INK }} data-testid={`aal-mnav-${n.id}`}>{n.label}</button>
            ))}
          </nav>
        )}
      </header>

      {/* ── HERO ── */}
      <section id="asset" className="relative overflow-hidden" data-testid="aal-hero">
        <div className="absolute inset-0">
          <img src={cfg.hero.image} alt={cfg.name} className="w-full h-full object-cover" style={{ objectPosition: cfg.hero.imagePosition || 'center' }} fetchPriority="high" />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, rgba(14,20,18,0.86) 0%, rgba(14,20,18,0.68) 45%, rgba(14,20,18,0.22) 100%)' }} />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(14,20,18,0.35) 0%, rgba(14,20,18,0) 35%, rgba(14,20,18,0.55) 100%)' }} />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-16 sm:pt-20 sm:pb-24 lg:pt-28 lg:pb-32 min-h-[78vh] lg:min-h-[86vh] flex flex-col justify-end lg:justify-center">
          <div className="max-w-2xl">
            <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[10px] sm:text-[11px] font-semibold tracking-[0.26em] uppercase" style={{ color: '#E8DCC7' }}>
              {cfg.hero.kicker.map((k, i) => (
                <React.Fragment key={k}>
                  {i > 0 && <span className="opacity-50">|</span>}
                  <span>{k}</span>
                </React.Fragment>
              ))}
            </div>
            <h1 className="mt-4 font-serif text-[2.1rem] leading-[1.06] sm:text-5xl lg:text-6xl xl:text-[4.2rem] tracking-tight" data-testid="aal-hero-title">
              <span style={{ color: '#FFF7EE' }}>{cfg.hero.title1}</span><br />
              <em className="not-italic font-light" style={{ color: '#EBD9A6', fontStyle: 'italic' }}>{cfg.hero.title2}</em>
            </h1>
            <p className="mt-5 text-[15px] sm:text-lg leading-relaxed max-w-xl" style={{ color: '#E6E1D6' }}>
              {cfg.hero.text}
            </p>
            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              {/* ★ Fase 95 — CTA primaria Doc 02 (apre il form: step reale del funnel = richiesta analisi) */}
              <PrimaryBtn onClick={() => openForm(d.ctaPrimary)} testId="aal-hero-cta" className="w-full sm:w-auto text-left">
                {d.ctaPrimary} <ArrowRight className="w-4 h-4 shrink-0" />
              </PrimaryBtn>
              <button
                type="button" onClick={() => scrollTo('architettura')}
                className="aal-btn-ghost inline-flex items-center justify-center gap-2 rounded-xl px-6 h-12 text-[13px] sm:text-sm font-semibold w-full sm:w-auto"
                data-testid="aal-hero-secondary"
              >
                <PlayCircle className="w-4 h-4" /> {t.heroSecondary}
              </button>
            </div>
            <NoObligationNote lang={lang} theme="dark" color="#D9D2C5" iconColor="#EBD9A6" className="mt-3 !justify-start" testId="aal-hero-no-obligation" compact />
          </div>
          <div
            className="mt-8 lg:mt-0 lg:absolute lg:right-8 lg:bottom-10 inline-flex items-start gap-3 rounded-2xl border px-4 py-3 max-w-xs self-start"
            style={{ background: 'rgba(14,20,18,0.62)', borderColor: 'rgba(255,255,255,0.22)', backdropFilter: 'blur(12px)' }}
            data-testid="aal-hero-badge"
          >
            <span className="w-9 h-9 rounded-full grid place-items-center shrink-0" style={{ background: 'rgba(255,255,255,0.12)' }}>
              <MapPin className="w-4 h-4" style={{ color: '#FFF7EE' }} />
            </span>
            <span>
              <span className="block text-[11px] font-bold tracking-[0.22em] uppercase" style={{ color: '#FFF7EE' }}>{cfg.hero.badgeTitle}</span>
              <span className="block text-[12px] leading-snug mt-0.5" style={{ color: '#D9D2C5' }}>{cfg.hero.badgeText}</span>
            </span>
          </div>
        </div>
      </section>

      {/* ── Trust strip ── */}
      <section className="border-b" style={{ background: CREAM_2, borderColor: LINE }} data-testid="aal-trust">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-0 lg:divide-x" style={{ borderColor: LINE }}>
          {t.trust.map((x) => (
            <div key={x.t} className="flex items-center gap-3 lg:px-6 first:lg:pl-0 last:lg:pr-0">
              <x.icon className="w-6 h-6 shrink-0" style={{ color: BURGUNDY }} strokeWidth={1.6} />
              <span className="text-[13px] leading-snug font-medium" style={{ color: INK }}>{x.t}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── ★ Fase 95 (Doc 02) — Scheda asset: asset + destinatario, disponibilità SOLO se verificata (dati live CRM) ── */}
      <section id="scheda" className="relative scroll-mt-16" data-testid="aal-sheet">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_minmax(0,420px)] gap-6 lg:gap-12 items-end">
            <div>
              <Kicker>{d.sheet.kicker}</Kicker>
              <SectionTitle className="mt-3" testId="aal-sheet-title">{d.sheet.title}</SectionTitle>
            </div>
            <p className="text-[15px] leading-relaxed lg:pb-1" style={{ color: INK_SOFT }} data-testid="aal-sheet-intro">{d.sheet.intro}</p>
          </div>

          <div className="mt-10 grid grid-cols-1 xl:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)] gap-5">
            {/* Fatti (statici dalla scheda ufficiale + live dal CRM) */}
            <div className="aal-card rounded-2xl p-6 sm:p-7 !transform-none" data-testid="aal-sheet-facts">
              <dl className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-5">
                <Fact label={L.asset} value={cfg.assetName || cfg.name} testId="aal-fact-asset" />
                <Fact label={L.location} value={cfg.place} testId="aal-fact-location" />
                <Fact label={L.floors} value={d.sheet.facts.floors} testId="aal-fact-floors" />
                <Fact label={L.units} value={d.sheet.facts.units} testId="aal-fact-units" />
                <Fact label={L.delivery} value={d.sheet.facts.delivery} testId="aal-fact-delivery" />
                <Fact
                  label={L.from}
                  loading={!asset.loaded}
                  value={asset.live && asset.startingFrom ? fmtEur(asset.startingFrom, lang) : L.pending}
                  testId="aal-fact-price"
                />
              </dl>

              {/* Disponibilità: mostrata SOLO se verificata (aggregati live dalle unità CRM) */}
              <div className="mt-6 rounded-xl border p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4" style={{ borderColor: LINE, background: '#F3EEE4' }} data-testid="aal-sheet-availability" data-verified={availabilityVerified ? 'true' : 'false'}>
                <div className="flex items-center gap-3 min-w-0">
                  <span className="w-11 h-11 rounded-full grid place-items-center shrink-0" style={{ background: FOREST }}>
                    <Building2 className="w-5 h-5" style={{ color: '#FFF7EE' }} strokeWidth={1.8} aria-hidden="true" />
                  </span>
                  <div className="min-w-0">
                    <div className="text-[10.5px] font-semibold tracking-[0.18em] uppercase" style={{ color: INK_SOFT }}>{L.availability}</div>
                    <div className="mt-0.5 font-serif text-xl sm:text-2xl leading-tight" style={{ color: INK }} data-testid="aal-sheet-availability-value">
                      {!asset.loaded ? (
                        <span className="aal-skeleton" aria-hidden="true" />
                      ) : availabilityVerified ? (
                        <><b style={{ color: FOREST }}>{asset.available}</b> {L.unitsOf} {asset.total} {L.available}</>
                      ) : (
                        <span className="inline-flex items-center gap-2"><Hourglass className="w-4 h-4" style={{ color: BURGUNDY }} aria-hidden="true" /> {L.pending}</span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="sm:text-right shrink-0">
                  <div className="text-[10.5px] font-semibold tracking-[0.18em] uppercase" style={{ color: INK_SOFT }}>{L.verifiedAt}</div>
                  <div className="mt-0.5 inline-flex items-center gap-1.5 text-[13px] font-semibold" style={{ color: INK }} data-testid="aal-sheet-verified-at">
                    <CheckCircle2 className="w-4 h-4" style={{ color: availabilityVerified && asset.verifiedAt ? FOREST : INK_SOFT }} aria-hidden="true" />
                    {!asset.loaded ? <span className="aal-skeleton" aria-hidden="true" /> : (availabilityVerified && asset.verifiedAt ? fmtDate(asset.verifiedAt, lang) : L.pending)}
                  </div>
                </div>
              </div>

              <dl className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-x-6 gap-y-4">
                <Fact label={L.plan} value={d.sheet.facts.plan} testId="aal-fact-plan" />
                <Fact label={L.deposit} value={d.sheet.facts.deposit} testId="aal-fact-deposit" />
                <Fact label={L.docs} value={d.sheet.facts.docs} testId="aal-fact-docs" />
              </dl>
              <p className="mt-5 text-[12px] leading-relaxed" style={{ color: INK_SOFT }} data-testid="aal-sheet-note">{d.sheet.note}</p>
            </div>

            {/* Per chi è / Per chi non è */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="aal-card rounded-2xl p-5 sm:p-6 !transform-none" data-testid="aal-sheet-for">
                <div className="flex items-center gap-2.5">
                  <CheckCircle2 className="w-6 h-6 shrink-0" style={{ color: FOREST }} strokeWidth={1.8} aria-hidden="true" />
                  <h3 className="font-serif text-[19px] leading-tight" style={{ color: INK }}>{d.sheet.forWho.title}</h3>
                </div>
                <ul className="mt-4 space-y-3">
                  {d.sheet.forWho.items.map((x) => (
                    <li key={x} className="flex items-start gap-2.5 text-[13.5px] leading-relaxed" style={{ color: INK_SOFT }}>
                      <span className="w-1.5 h-1.5 rounded-full shrink-0 mt-2" style={{ background: FOREST }} aria-hidden="true" /> {x}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="aal-card rounded-2xl p-5 sm:p-6 !transform-none" data-testid="aal-sheet-notfor">
                <div className="flex items-center gap-2.5">
                  <XCircle className="w-6 h-6 shrink-0" style={{ color: BURGUNDY }} strokeWidth={1.8} aria-hidden="true" />
                  <h3 className="font-serif text-[19px] leading-tight" style={{ color: INK }}>{d.sheet.notFor.title}</h3>
                </div>
                <ul className="mt-4 space-y-3">
                  {d.sheet.notFor.items.map((x) => (
                    <li key={x} className="flex items-start gap-2.5 text-[13.5px] leading-relaxed" style={{ color: INK_SOFT }}>
                      <span className="w-1.5 h-1.5 rounded-full shrink-0 mt-2" style={{ background: BURGUNDY }} aria-hidden="true" /> {x}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Credenze ── */}
      <section className="relative" style={{ background: CREAM_2 }} data-testid="aal-myths">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_minmax(0,340px)] gap-6 lg:gap-12 items-end">
            <div>
              <Kicker>{cfg.myths.kicker}</Kicker>
              <SectionTitle className="mt-3" testId="aal-myths-title">{cfg.myths.title}</SectionTitle>
            </div>
            <p className="text-[15px] leading-relaxed lg:pb-1" style={{ color: INK_SOFT }}>{cfg.myths.intro}</p>
          </div>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
            {cfg.myths.items.map((m, i) => (
              <article key={m.myth} className="aal-card rounded-2xl overflow-hidden flex flex-col" data-testid={`aal-myth-${i + 1}`}>
                <div className="h-40 sm:h-44 overflow-hidden">
                  <img src={m.img} alt="" className="w-full h-full object-cover grayscale-[35%]" loading="lazy" />
                </div>
                <div className="p-5 flex flex-col gap-3">
                  <div className="flex items-start gap-2.5">
                    <XCircle className="w-5 h-5 shrink-0 mt-0.5" style={{ color: BURGUNDY }} strokeWidth={1.8} />
                    <h3 className="font-serif text-[17px] leading-snug" style={{ color: INK }}>{m.myth}</h3>
                  </div>
                  <div className="h-px w-full" style={{ background: LINE }} />
                  <div className="flex items-start gap-2.5">
                    <CheckCircle2 className="w-5 h-5 shrink-0 mt-0.5" style={{ color: FOREST }} strokeWidth={1.8} />
                    <p className="text-[13.5px] leading-relaxed" style={{ color: INK_SOFT }}>{m.truth}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ── Infrastruttura patrimoniale ── */}
      <section id="infrastruttura" className="relative scroll-mt-16" style={{ background: '#FBF8F2' }} data-testid="aal-infra">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 grid grid-cols-1 lg:grid-cols-[minmax(0,460px)_1fr] gap-10 lg:gap-14 items-center">
          <div className="rounded-3xl overflow-hidden aspect-[4/5] lg:aspect-auto lg:h-[560px]">
            <img src={cfg.infra.image} alt={cfg.name} className="w-full h-full object-cover" loading="lazy" />
          </div>
          <div>
            <Kicker>{cfg.infra.kicker}</Kicker>
            <SectionTitle className="mt-3" testId="aal-infra-title">{cfg.infra.title}</SectionTitle>
            <p className="mt-5 text-[15px] sm:text-lg leading-relaxed max-w-2xl" style={{ color: INK_SOFT }}>{cfg.infra.text}</p>
            <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-4">
              {cfg.infra.pillars.map((p) => (
                <div key={p.t} className="aal-card rounded-2xl p-4 sm:p-5" data-testid={`aal-pillar-${p.t.toLowerCase().split(' ')[0]}`}>
                  <p.icon className="w-7 h-7" style={{ color: BURGUNDY }} strokeWidth={1.5} />
                  <div className="mt-3 font-serif text-[17px] leading-tight" style={{ color: INK }}>{p.t}</div>
                  <p className="mt-1.5 text-[13px] leading-relaxed" style={{ color: INK_SOFT }}>{p.d}</p>
                </div>
              ))}
            </div>
            <blockquote className="mt-8 flex items-center gap-4">
              <span className="hidden sm:block h-px w-12" style={{ background: BURGUNDY }} />
              <p className="font-serif italic text-lg sm:text-xl leading-snug" style={{ color: INK }}>&ldquo;{cfg.infra.quote}&rdquo;</p>
            </blockquote>
          </div>
        </div>
      </section>

      {/* ── Architettura (gallery) ── */}
      <section id="architettura" className="relative scroll-mt-16" data-testid="aal-arch">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_minmax(0,360px)] gap-6 lg:gap-12 items-end">
            <div>
              <Kicker>{cfg.arch.kicker}</Kicker>
              <SectionTitle className="mt-3" testId="aal-arch-title">{cfg.arch.title}</SectionTitle>
            </div>
            <p className="text-[15px] leading-relaxed" style={{ color: INK_SOFT }}>{cfg.arch.intro}</p>
          </div>
          <div className={`mt-10 grid grid-cols-2 ${cfg.arch.items.length >= 5 ? 'lg:grid-cols-5' : 'lg:grid-cols-4'} gap-4 sm:gap-5`}>
            {cfg.arch.items.map((g, i) => (
              <figure key={g.cap} className="group" data-testid={`aal-gallery-${i + 1}`}>
                <div className="rounded-2xl overflow-hidden aspect-[4/5] border" style={{ borderColor: LINE }}>
                  <img src={g.img} alt={g.cap} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.04]" loading="lazy" />
                </div>
                <figcaption className="mt-3">
                  <div className="font-serif text-[15px] sm:text-base leading-snug" style={{ color: INK }}>{g.cap}</div>
                  {g.sub && <p className="mt-1 text-[12.5px] leading-relaxed" style={{ color: INK_SOFT }}>{g.sub}</p>}
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* ── ★ Fase 95 (Doc 02) — Dossier verificabile + confronto opportunità / rischi ── */}
      <section id="dossier" className="relative scroll-mt-16" style={{ background: CREAM_2 }} data-testid="aal-dossier">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_minmax(0,420px)] gap-6 lg:gap-12 items-end">
            <div>
              <Kicker>{d.dossier.kicker}</Kicker>
              <SectionTitle className="mt-3" testId="aal-dossier-title">{d.dossier.title}</SectionTitle>
            </div>
            <p className="text-[15px] leading-relaxed lg:pb-1" style={{ color: INK_SOFT }}>{d.dossier.intro}</p>
          </div>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
            {d.dossier.items.map((it, i) => (
              <article key={it.t} className="aal-card rounded-2xl p-5 sm:p-6 flex flex-col" data-testid={`aal-dossier-item-${i + 1}`}>
                <div className="flex items-start justify-between gap-3">
                  <it.icon className="w-7 h-7 shrink-0" style={{ color: BURGUNDY }} strokeWidth={1.5} aria-hidden="true" />
                  <StatusBadge status={it.status} label={d.dossier.statusLabels[it.status]} testId={`aal-dossier-item-${i + 1}-status`} />
                </div>
                <h3 className="mt-4 font-serif text-[18px] leading-tight" style={{ color: INK }}>{it.t}</h3>
                <p className="mt-2 text-[13.5px] leading-relaxed" style={{ color: INK_SOFT }}>{it.d}</p>
              </article>
            ))}
          </div>
          {/* TODO esplicito (asset mancante): nessuna immagine non datata spacciata per prova */}
          <p className="mt-5 inline-flex items-start gap-2 text-[12.5px] leading-relaxed rounded-xl px-3.5 py-2.5" style={{ background: STATUS_STYLE.todo.bg, color: INK_SOFT }} data-testid="aal-dossier-todo">
            <HardHat className="w-4 h-4 shrink-0 mt-0.5" style={{ color: BURGUNDY }} aria-hidden="true" /> <span><b style={{ color: INK }}>{d.dossier.statusLabels.todo}:</b> {d.dossier.todoNote}</span>
          </p>

          {/* Opportunità e rischi */}
          <div className="mt-16 pt-14 border-t" style={{ borderColor: LINE }} data-testid="aal-risks">
            <div className="grid grid-cols-1 lg:grid-cols-[1fr_minmax(0,420px)] gap-6 lg:gap-12 items-end">
              <div>
                <Kicker>{d.risks.kicker}</Kicker>
                <SectionTitle className="mt-3" testId="aal-risks-title">{d.risks.title}</SectionTitle>
              </div>
              <p className="text-[15px] leading-relaxed lg:pb-1" style={{ color: INK_SOFT }}>{d.risks.intro}</p>
            </div>
            <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-5">
              <div className="aal-card rounded-2xl p-6 sm:p-7 !transform-none" data-testid="aal-risks-opportunities">
                <div className="flex items-center gap-2.5">
                  <TrendingUp className="w-6 h-6" style={{ color: FOREST }} strokeWidth={1.8} aria-hidden="true" />
                  <h3 className="font-serif text-[20px] leading-tight" style={{ color: INK }}>{d.risks.opportunities.title}</h3>
                </div>
                <ul className="mt-5 space-y-3.5">
                  {d.risks.opportunities.items.map((x) => (
                    <li key={x} className="flex items-start gap-3 text-[14px] leading-relaxed" style={{ color: INK_SOFT }}>
                      <span className="w-6 h-6 rounded-full grid place-items-center shrink-0 mt-0.5" style={{ background: '#E3EEE8' }}>
                        <CheckCircle2 className="w-4 h-4" style={{ color: FOREST }} strokeWidth={2} aria-hidden="true" />
                      </span>
                      {x}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="aal-card rounded-2xl p-6 sm:p-7 !transform-none" data-testid="aal-risks-risks">
                <div className="flex items-center gap-2.5">
                  <AlertTriangle className="w-6 h-6" style={{ color: BURGUNDY }} strokeWidth={1.8} aria-hidden="true" />
                  <h3 className="font-serif text-[20px] leading-tight" style={{ color: INK }}>{d.risks.risks.title}</h3>
                </div>
                <ul className="mt-5 space-y-4">
                  {d.risks.risks.items.map((x, i) => (
                    <li key={x.r} className="flex items-start gap-3" data-testid={`aal-risk-${i + 1}`}>
                      <span className="w-6 h-6 rounded-full grid place-items-center shrink-0 mt-0.5" style={{ background: '#F3E3E0' }}>
                        <AlertTriangle className="w-3.5 h-3.5" style={{ color: BURGUNDY }} strokeWidth={2} aria-hidden="true" />
                      </span>
                      <div className="min-w-0">
                        <div className="text-[14px] font-semibold leading-snug" style={{ color: INK }}>{x.r}</div>
                        <p className="mt-1 text-[13px] leading-relaxed" style={{ color: INK_SOFT }}>
                          <ShieldCheck className="inline w-3.5 h-3.5 mr-1 -mt-0.5" style={{ color: FOREST }} aria-hidden="true" />{x.how}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <p className="mt-6 text-[13px] leading-relaxed" style={{ color: INK_SOFT }} data-testid="aal-risks-note">{d.risks.note}</p>
            <NoObligationNote lang={lang} theme="light" className="mt-3 !justify-start" testId="aal-risks-no-obligation" compact />
          </div>
        </div>
      </section>

      {/* ── Perché … perché ora ── */}
      <section id="perche" className="relative scroll-mt-16" data-testid="aal-why">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_minmax(0,420px)] gap-6 lg:gap-12 items-end">
            <div>
              <Kicker>{cfg.why.kicker}</Kicker>
              <SectionTitle className="mt-3" testId="aal-why-title">{cfg.why.title}</SectionTitle>
            </div>
            <p className="text-[15px] leading-relaxed" style={{ color: INK_SOFT }}>{cfg.why.intro}</p>
          </div>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
            {cfg.why.items.map((w, i) => (
              <div key={w.t} className="aal-card rounded-2xl p-5" data-testid={`aal-why-${i + 1}`}>
                <w.icon className="w-7 h-7" style={{ color: BURGUNDY }} strokeWidth={1.5} />
                <div className="mt-3 font-serif text-[17px] leading-tight" style={{ color: INK }}>{w.t}</div>
                <p className="mt-1.5 text-[13px] leading-relaxed" style={{ color: INK_SOFT }}>{w.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── ★ Fase 95 (Doc 02) — Percorso: Form → Qualifica → Zoom → Pass ── */}
      <section id="percorso" className="relative scroll-mt-16" style={{ background: '#FBF8F2' }} data-testid="aal-journey">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_minmax(0,420px)] gap-6 lg:gap-12 items-end">
            <div>
              <Kicker>{d.journey.kicker}</Kicker>
              <SectionTitle className="mt-3" testId="aal-journey-title">{d.journey.title}</SectionTitle>
            </div>
            <p className="text-[15px] leading-relaxed lg:pb-1" style={{ color: INK_SOFT }}>{d.journey.intro}</p>
          </div>
          <ol className="mt-10 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4" data-testid="aal-journey-steps">
            {d.journey.steps.map((s, i) => {
              const current = i === 0;
              return (
                <li key={s.t} className="aal-card rounded-2xl p-5 sm:p-6 flex flex-col relative !transform-none" style={current ? { borderColor: BURGUNDY, boxShadow: `0 0 0 1px ${BURGUNDY}` } : undefined} data-testid={`aal-journey-step-${i + 1}`} data-current={current ? 'true' : 'false'}>
                  <div className="flex items-center justify-between gap-3">
                    <span className="font-serif text-[15px]" style={{ color: BURGUNDY }}>{String(i + 1).padStart(2, '0')}</span>
                    {current ? (
                      <span className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[10.5px] font-bold tracking-[0.1em] uppercase" style={{ background: BURGUNDY, color: '#FFF7EE' }} data-testid="aal-journey-you-are-here">
                        <MapPin className="w-3 h-3" aria-hidden="true" /> {d.journey.youAreHere}
                      </span>
                    ) : (
                      <span className="w-10 h-10 rounded-full border grid place-items-center" style={{ borderColor: LINE }}>
                        <s.icon className="w-5 h-5" style={{ color: BURGUNDY }} strokeWidth={1.6} aria-hidden="true" />
                      </span>
                    )}
                  </div>
                  <h3 className="mt-4 font-serif text-[18px] leading-tight" style={{ color: INK }}>{s.t}</h3>
                  <p className="mt-2 text-[13.5px] leading-relaxed" style={{ color: INK_SOFT }}>{s.d}</p>
                  {s.tag && <span className="mt-auto pt-4 text-[11px] font-semibold tracking-[0.12em] uppercase" style={{ color: BURGUNDY }}>{s.tag}</span>}
                </li>
              );
            })}
          </ol>
          <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-4">
            <PrimaryBtn onClick={() => openForm(d.ctaPrimary)} testId="aal-journey-cta" className="w-full sm:w-auto text-left">
              {d.ctaPrimary} <ArrowRight className="w-4 h-4 shrink-0" />
            </PrimaryBtn>
            <NoObligationNote lang={lang} theme="light" className="!justify-start" testId="aal-journey-no-obligation" compact />
          </div>
        </div>
      </section>

      {/* ── Verification Pass (★ Fase 95: include / NON include + date live + bridge hub) ── */}
      <section id="verification" className="relative overflow-hidden scroll-mt-16" style={{ background: FOREST }} data-testid="aal-vp">
        <div className="aal-grain" aria-hidden="true" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 grid grid-cols-1 lg:grid-cols-[1fr_minmax(0,330px)_minmax(0,330px)] gap-8 lg:gap-8 items-start">
          <div className="flex flex-col justify-center">
            <Kicker light>{cfg.vp.kicker}</Kicker>
            <SectionTitle light className="mt-3" testId="aal-vp-title">{t.vpTitle[0]}<br />{t.vpTitle[1]}</SectionTitle>
            <p className="mt-5 text-[15px] sm:text-lg leading-relaxed max-w-xl" style={{ color: '#D8E2DC' }}>
              {t.vpLead} <b style={{ color: '#FFF7EE' }}>{t.vpName}</b> {cfg.vp.textAfter}
            </p>

            {/* Date live dal CRM + prezzo (nessuna data inventata) */}
            <div className="mt-6 rounded-2xl border p-5 max-w-xl" style={{ borderColor: 'rgba(255,255,255,0.22)', background: 'rgba(255,247,238,0.08)', backdropFilter: 'blur(12px)' }} data-testid="aal-vp-dates-card">
              <div className="flex items-center justify-between gap-3">
                <div className="font-serif text-[17px]" style={{ color: '#FFF7EE' }}>{d.vpExtra.datesTitle}</div>
                <span className="rounded-full px-2.5 py-1 text-[11px] font-bold tracking-[0.08em] whitespace-nowrap" style={{ background: GOLD, color: FOREST_DEEP }} data-testid="aal-vp-price">{d.vpExtra.price}</span>
              </div>
              <ul className="mt-3 space-y-1.5">
                {vpDates.length === 0 && <li className="text-[13px]" style={{ color: '#B9C8C0' }} data-testid="aal-vp-dates-empty">{d.vpExtra.datesEmpty}</li>}
                {vpDates.slice(0, 4).map((x) => (
                  <li key={x.id} className="flex items-center justify-between gap-2 text-[13px]" style={{ color: '#FFF7EE' }} data-testid="aal-vp-date">
                    <span className="inline-flex items-center gap-2"><CalendarClock className="w-4 h-4" style={{ color: GOLD }} aria-hidden="true" /> {x.label}</span>
                    {typeof x.left === 'number' && <span className="text-[12px]" style={{ color: x.left > 0 ? '#B9C8C0' : '#F2C4B8' }}>{x.left > 0 ? `${x.left} ${d.vpExtra.seatsLabel}` : d.vpExtra.soldOut}</span>}
                  </li>
                ))}
              </ul>
              <p className="mt-3 text-[11.5px] leading-relaxed" style={{ color: '#9FB3A9' }}>{d.vpExtra.datesNote}</p>
            </div>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <PrimaryBtn onClick={() => openForm(t.vpCta)} testId="aal-vp-cta" className="w-full sm:w-auto">
                {t.vpCta} <ArrowRight className="w-4 h-4 shrink-0" />
              </PrimaryBtn>
              <Link to={hubHref} onClick={onHubClick} className="aal-link-ghost inline-flex items-center justify-center gap-2 rounded-xl px-6 h-12 text-[13px] sm:text-sm font-semibold w-full sm:w-auto whitespace-nowrap" data-testid="aal-vp-hub-cta">
                {d.vpExtra.hubCta} <ArrowRight className="w-4 h-4 shrink-0" />
              </Link>
            </div>
            <p className="mt-3 inline-flex items-center gap-2 text-[12px]" style={{ color: '#B9C8C0' }}>
              <Lock className="w-3.5 h-3.5" /> {t.vpNote}
            </p>
            <NoObligationNote lang={lang} theme="dark" color="#B9C8C0" iconColor={GOLD} className="mt-2 !justify-start" testId="aal-vp-no-obligation" compact />
          </div>

          <div className="rounded-2xl p-6 sm:p-7 h-full" style={{ background: '#FBF8F2', color: INK }} data-testid="aal-vp-includes">
            <div className="font-serif text-xl sm:text-2xl leading-tight">{t.vpIncludesTitle[0]}<br />{t.vpIncludesTitle[1]}</div>
            <ul className="mt-5 space-y-4">
              {t.vpIncludes.map((x) => (
                <li key={x} className="flex items-start gap-3">
                  <span className="w-6 h-6 rounded-full grid place-items-center shrink-0 mt-0.5" style={{ background: FOREST }}>
                    <CheckCircle2 className="w-4 h-4" style={{ color: '#FFF7EE' }} strokeWidth={2} />
                  </span>
                  <span className="text-[14px] leading-relaxed" style={{ color: INK_SOFT }}>{x}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* ★ Fase 95 — Cosa NON include il Pass (trasparenza Doc 02) */}
          <div className="rounded-2xl p-6 sm:p-7 border h-full" style={{ background: 'rgba(255,247,238,0.08)', borderColor: 'rgba(255,255,255,0.22)', backdropFilter: 'blur(12px)', color: '#FFF7EE' }} data-testid="aal-vp-not-includes">
            <div className="font-serif text-xl sm:text-2xl leading-tight">{d.vpExtra.notIncludesTitle}</div>
            <ul className="mt-5 space-y-4">
              {d.vpExtra.notIncludes.map((x) => (
                <li key={x} className="flex items-start gap-3">
                  <span className="w-6 h-6 rounded-full grid place-items-center shrink-0 mt-0.5 border" style={{ borderColor: 'rgba(255,255,255,0.4)' }}>
                    <X className="w-3.5 h-3.5" style={{ color: GOLD }} strokeWidth={2.2} aria-hidden="true" />
                  </span>
                  <span className="text-[14px] leading-relaxed" style={{ color: '#D8E2DC' }}>{x}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        {/* ★ Fase 68/69 — video racconto Verification Pass Albania */}
        <div className="relative px-4 sm:px-6 lg:px-8 pb-16 sm:pb-20">
          <VpRecapVideo lang={lang} dark accent={GOLD} testId="aml-vp-video" />
        </div>
      </section>

      {/* ── ★ 2026-10-19 — Testimonianze video (fonte unica lib/testimonials.js) ── */}
      <TestimonialsSection lang={lang} theme="light" testIdPrefix="aal" id="testimonianze" />

      {/* ── ★ Fase 95 (Doc 02) — Prove specifiche Narea (brochure, disponibilità live, testimonianze, date Pass) ── */}
      <ProofsSection c={proofs} tokens={TOKENS} vpDates={vpDates} testIdPrefix="aal-proofs" id="prove" />

      {/* ── FAQ (esistenti + ★ Fase 95 extra: include/non include, documenti, disponibilità, dopo la richiesta) ── */}
      <section id="faq" className="relative scroll-mt-16" data-testid="aal-faq">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 grid grid-cols-1 lg:grid-cols-[minmax(0,380px)_1fr] gap-8 lg:gap-14">
          <div>
            <Kicker>{t.faqKicker}</Kicker>
            <SectionTitle className="mt-3" testId="aal-faq-title">{t.faqTitle}</SectionTitle>
            <p className="mt-4 text-[15px] leading-relaxed" style={{ color: INK_SOFT }}>{cfg.faq.intro}</p>
            <div className="mt-8 rounded-2xl overflow-hidden aspect-[16/10] hidden lg:block border" style={{ borderColor: LINE }}>
              <img src={cfg.faq.image} alt="" className="w-full h-full object-cover" loading="lazy" />
            </div>
          </div>
          <Accordion type="single" collapsible className="space-y-3">
            {faqItems.map((f, i) => (
              <AccordionItem key={f.q} value={`faq-${i}`} className="aal-accordion-item" data-testid={`aal-faq-item-${i + 1}`}>
                <AccordionTrigger className="font-serif text-left text-[16px] sm:text-[17px] py-4 hover:no-underline" style={{ color: INK }}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[14px] leading-relaxed pb-5" style={{ color: INK_SOFT }}>
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* ── Final CTA ── */}
      <section className="relative overflow-hidden" data-testid="aal-final">
        <div className="absolute inset-0">
          <img src={cfg.final.image} alt="" className="w-full h-full object-cover object-center" loading="lazy" />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, rgba(14,20,18,0.88) 0%, rgba(14,20,18,0.7) 50%, rgba(14,20,18,0.35) 100%)' }} />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 grid grid-cols-1 lg:grid-cols-[1fr_minmax(0,400px)] gap-10 items-center">
          <div className="max-w-2xl">
            <Kicker light>{cfg.final.kicker}</Kicker>
            <h2 className="mt-3 font-serif text-[2rem] sm:text-5xl leading-[1.08] tracking-tight" data-testid="aal-final-title">
              <span style={{ color: '#FFF7EE' }}>{cfg.final.title1}</span><br />
              <span style={{ color: '#EBD9A6', fontStyle: 'italic' }}>{cfg.final.title2}</span>
            </h2>
            <p className="mt-5 text-[15px] sm:text-lg leading-relaxed max-w-xl" style={{ color: '#E6E1D6' }}>{cfg.final.text}</p>
          </div>
          <div className="flex flex-col items-stretch lg:items-end gap-3">
            <PrimaryBtn onClick={() => openForm(d.ctaPrimary)} testId="aal-final-cta" className="w-full lg:w-auto !h-[3.4rem] !px-7 text-left">
              {d.ctaPrimary} <ArrowRight className="w-4 h-4 shrink-0" />
            </PrimaryBtn>
            <p className="inline-flex items-center gap-2 text-[12px] lg:justify-end" style={{ color: '#C9C2B5' }}>
              <Lock className="w-3.5 h-3.5" /> {t.finalNote}
            </p>
            <NoObligationNote lang={lang} theme="dark" color="#D9D2C5" iconColor="#EBD9A6" className="lg:!justify-end !justify-start" testId="aal-final-no-obligation" compact />
          </div>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer className="border-t" style={{ background: '#0E1512', borderColor: 'rgba(255,255,255,0.08)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col lg:flex-row lg:items-center justify-between gap-6">
          <div>
            <img src="/funnels/hcf-logo.png" alt="HCF Property" className="h-8 w-auto" />
            <p className="text-[11px] mt-2" style={{ color: '#9AA39E' }}>© {new Date().getFullYear()} HCF Property · {cfg.name}</p>
          </div>
          <nav className="flex flex-wrap gap-x-5 gap-y-2 text-[12px]" style={{ color: '#C9C2B5' }} aria-label={t.footerSections}>
            {NAV.map((n) => (
              <button key={n.id} type="button" onClick={() => scrollTo(n.id)} className="hover:text-white transition-colors" data-testid={`aal-fnav-${n.id}`}>{n.label}</button>
            ))}
          </nav>
          <div className="flex flex-wrap gap-x-5 gap-y-2 text-[12px] items-center" style={{ color: '#C9C2B5' }}>
            <Link to="/privacy" className="underline hover:text-white" data-testid="aal-footer-privacy">{t.footerPrivacy}</Link>
            <Link to="/cookie-policy" className="underline hover:text-white" data-testid="aal-footer-cookies">{t.footerCookies}</Link>
            <Link to={cfg.homeHref || '/f/it'} className="underline hover:text-white" data-testid="aal-footer-funnel">{t.footerFunnel}</Link>
            <span className="tracking-[0.25em]" data-testid="aal-footer-code">{cfg.code}</span>
          </div>
        </div>
      </footer>

      {/* ── Mobile sticky CTA ── */}
      <div className="lg:hidden fixed bottom-0 inset-x-0 z-30 p-3" style={{ background: 'linear-gradient(180deg, rgba(246,241,232,0) 0%, rgba(246,241,232,0.96) 40%)' }}>
        <PrimaryBtn onClick={() => openForm(d.ctaPrimary)} className="w-full shadow-xl" testId="aal-sticky-cta">
          {d.ctaPrimary} <ArrowRight className="w-4 h-4 shrink-0" />
        </PrimaryBtn>
      </div>
      <div className="lg:hidden h-20" aria-hidden="true" />

      {/* ★ Fase 95 — dialog 3 step: contatti → qualifica → percorso HCF.
          Richiesta cliente: dal funnel Narea NESSUN salto diretto al calendario — prima il percorso
          completo (/f/it), poi la Zoom strategica col CEO → `successHref` (UTM preservati). */}
      <ZoomLeadDialog
        open={formOpen}
        onOpenChange={setFormOpen}
        funnel={slug}
        propertySlug={cfg.propertySlug}
        leadMessage={cfg.leadMessage}
        lang={lang}
        brochureEmail={cfg.brochureEmail}
        t={d.dlg}
        tokens={TOKENS}
        testIdPrefix="aal"
        intent="dossier"
        successHref={d.successHref}
        bridge={d.dlg.bridge ? { ...d.dlg.bridge, href: hubHref, cta: d.vpExtra.hubCta } : null}
      />
    </div>
  );
}
